import { ENV } from '../utils';

export class User {
    basePath = ENV.BASE_PATH

    async getMe(accessToken) {
        try {
            const url = `${this.basePath}${ENV.API_ROUTES.USER_ME}`;
            console.log(url);
            const params = {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${accessToken}`
                },
            };

            const response = await fetch(url, params);
            const result = await response.json();

            if (response.status !== 200 ) throw result;
            return result;

        } catch (error) {
            console.error(error);
            //throw error;
        }
    };

    async getUsers(accessToken) {
        try {
            const url = `${this.basePath}${ENV.API_ROUTES.USERS}`;
            console.log(url);
            
            const params = {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${accessToken}`
                }
            };

            const response = await fetch(url, params);
            const result = await response.json()

            if(response.status !== 200) throw result;
            return result;
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    async createUser(accessToken, userData) {
        try {
            const url = `${this.basePath}${ENV.API_ROUTES.USER}`;
            console.log(url);
            const params = {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${accessToken}`
                },
                body: JSON.stringify(userData)
            }

            const response = await fetch(url, params);
            const result = await response.json();

            if(response.status !== 201) throw result;
            return result;

        } catch (error) {
            console.log(error);
            throw error
        }
    }

    async updateUser(accessToken, idUser, userData) {
        try {

            const url = `${this.basePath}${ENV.API_ROUTES.USER}/${idUser}`;
            const params = {
                method: "PUT",
                headers: {
                    Authorization: `Bearer ${accessToken}`
                },
                body: JSON.stringify(userData),
            }

            const response = await fetch(url, params);
            console.log( response)
            const result = await response.json();

            if(response.status !== 200) throw result;
            return result;

        } catch (error) {
            console.log(error);
            throw error
        }
    }

    async deleteUser(accessToken, idUser) {
        try {
            const url = `${this.basePath}${ENV.API_ROUTES.USER}/${idUser}`;
            console.log(url)
            const params = {
                method: "DELETE",
                headers: {
                    Authorization: `Bearer ${accessToken}`
                },
            };
            
            const response = await fetch(url, params);
            // const result = await response.json();
            const result ={}

            if(response.status !== 200) throw result;
            return result;

        } catch (error) {
            console.log(error)
            throw error
        }
    }

    async approveUser(accessToken, idUser) {
        try {

            const url = `${this.basePath}${ENV.API_ROUTES.USER}/${idUser}${ENV.API_ROUTES.APPROVE_USER}`;
            console.log(url)
            const params = {
                method : "PUT",
                headers: {
                    Authorization: `Bearer ${accessToken}`
                }
            }

            const response = await fetch(url, params);
           // const result = await response.json();
            const result ={}
            if(response.status !== 200) throw result;
            return result;

        } catch (error) {
            console.log(error)
            throw error
        }
    }
}